import { Pipe, PipeTransform } from '@angular/core';
import '../utils/string-extensions';

// FIXME Passar para o conversai-components.

@Pipe({
    name: 'initialLetters',
})
export class InitialLettersPipe implements PipeTransform {
    transform(value: string, n: number = 2): string {
        return value.getFirstLetterOfEachWord(n);
    }
}
